import React									from 'react';
import ReactDOM									from 'react-dom';
import BLComponent								from '../../core/_BLComponent.jsx';

import MyCollectionHeader						from './_MyCollectionHeader.jsx';
import MyCollectionItemTypeNav					from './_MyCollectionItemTypeNav.jsx';
import AddItemSection							from './_AddItemSection.jsx';

import ErrorModal								from './_ErrorModal.jsx';
import ListHeader								from './_ListHeader.jsx';
import ItemView									from './_ItemView.jsx';
import CategoryTreeView							from './_CategoryTreeView.jsx';
import CategoryTreeModal						from './_CategoryTreeModal.jsx';
import ImportXMLModal							from './_ImportXMLModal.jsx';

import FTUXModal								from './modals/_FTUXModal.jsx';
import MyCollectionProtocol						from '../controller/MyCollectionProtocol.js';

import { MyCollectionUtils, AddItemUtil, CategoryUtil, ItemListUtil, CommonUtils } from '../controller/MyCollectionUtils.js';

export default class PersonalInventory extends BLComponent {
	constructor(props, context) {
		super(props, context);
		let reqItemType = blapp.util.getUrlVar("itemType");
		if (typeof reqItemType === "undefined") {
			reqItemType = "S";
		}
		const searchKeyword = blapp.util.getUrlVar("q");
		this.state = {
			activeStory: 0
			, nStories: 0
			, nListLotCnt: 0
			, nListItemCnt: 0
			, generalInvInfo:
			{
				nAllItemCount: 0
				, nAllItemLotCount: 0
				, nSetCount: 0
				, nSetLotCount: 0
				, nPartCount: 0
				, nPartLotCount: 0
				, nMinifigureCount: 0
				, nMinifigureLotCount: 0
				, nGearCount: 0
				, nGearLotCount: 0
				, nBookCount: 0
				, nBookLotCount: 0
				, nCatalogCount: 0
				, nCatalogLotCount: 0
				, listingOptions: {
					A: {}
					, S: {}
					, P: {}
					, B: {}
					, M: {}
					, G: {}
					, C: {}
				}
			}
			, dispItemType: ("SPMBGC".includes(reqItemType.toUpperCase())) ? reqItemType : "S"
			, dispError: false
			, itemAdded: {
				S: { items: [] }
			}
			, reloadList: false
			, uploadOption: -1
			, showTutorial: false
			, showImportExportMenu: false
			, showImportXMLModal: false
			, showCategoryTree: {
				A: false
				, S: false
				, P: false
				, B: false
				, M: false
				, G: false
				, C: false
			}
			, itemPage: {
				A: 1
				, S: 1
				, P: 1
				, B: 1
				, M: 1
				, G: 1
				, C: 1
			}
			, isLoggedIn: false
			, listItem: []
			, listCategory: {
				A: []
				, S: []
				, P: []
				, B: []
				, M: []
				, G: []
				, C: []
			}
			, strSearchKeyword: (typeof searchKeyword == "undefined")?"":searchKeyword
			, showCategoryModal: false
			, categoryTreeIter: 0
			, myCollectionConfig: {
				maxNoteLen: 100
			}
		}

		this.slickSettings = {
			dots: true,
			arrows: false,
			infinite: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			adaptiveHeight: true,
			swipeToSlide: true,
			afterChange: (index) => this.changeSlide(index)
		}
	}

	componentDidMount() {
		//this.setState({dispItemType: "S"});
		this.onPopState();

		this.getGenInvInfo();
		this.getListCategory();
		this.registerPopStateCallback((e) => this.onPopState(e));
		this.setState({ isLoggedIn: blapp.session.isLoggedIn() });
		blapp.session.onSessionUpdate(() => this.onSessionUpdate());

		if (!blapp.session.isLoggedIn()) blapp.refs.get("header").toggleMenu("login");
	}

	render() {
		const item = this.getCurrentItemType();
		const listItem = this.state.listItem;
		const isEmpty = ItemListUtil.isEmptyList(listItem);

		let bShowCategoryTree = (isEmpty)?false:this.state.showCategoryTree[this.state.dispItemType];
		
		return (
			<div>
				<div className="personal-inventory__header-full">
				{this.renderSectionHeader()
						}
				</div>
			<div className="main--white">
				<div id="main-content" className="main__content">
					<div className="personal-inventory__container">

						{this.renderSectionItemTypeNav()
						}
						{this.renderSectionAddItem(item)
						}
						{(bShowCategoryTree) ? this.renderSectionListWithCatalogTree(item) : this.renderSectionList(item)
						}
					</div>

				</div>

				{(this.state.showImportXMLModal) && <div>{this.renderImportXMLModal()}</div>}
				{(this.state.showTutorial) && <div>{this.renderFTUXModal()}</div>}
				{(this.state.showCategoryModal) && <React.Fragment>{this.renderCategoryTreeModal()}</React.Fragment>}
			</div>
			</div>
		);
	}

	renderSectionHeader() {

		return (
			<MyCollectionHeader key={this.state.strSearchKeyword} data={{ strSearchKeyword: this.state.strSearchKeyword }} func={{ doSearch: (keyword) => this.doSearch(keyword) }} />
		)
	}

	renderImportXMLModal() {
		const dispItemType = this.state.dispItemType;
		return (
			<ImportXMLModal data={{ itemType: dispItemType }}
				func={{
					closeImportXMLModal: () => this.closeImportXMLModal()
				}} />
		)
	}

	expandSearch() {

		const elementsTitle = document.getElementsByClassName("personal-inventory__show-only-mobile");
		elementsTitle[0].classList.toggle('personal-inventory__hide');
		const elementsSearch = document.getElementsByClassName("personal-inventory__header-search-mobile-view");
		elementsSearch[0].classList.toggle('personal-inventory__expand-full-width');
	}

	renderSectionItemTypeNav() {
		const generalInvInfo = this.state.generalInvInfo;
		const dispItemType = this.state.dispItemType;

		return (
			<MyCollectionItemTypeNav data={{ dispItemType: dispItemType, generalInvInfo: generalInvInfo }} func={{ changeItemType: (itemType) => this.changeItemType(itemType) }} />
		)
	}

	renderSectionAddItem(item) {
		if (item.itemType != "All") {
			return (
				<AddItemSection key={item.itemType + item.cnt} 
					data={{ myCollectionConfig: this.state.myCollectionConfig, AddItemUtil: AddItemUtil, item: item, dispItemType: this.state.dispItemType, itemAdded: this.getItemAdded(this.state.dispItemType) }} 
					func={{ 
						setItemAdded: (itemAdded, itemType) => this.setItemAdded(itemAdded, itemType), 
						clearItemAdded: (itemType) => this.clearItemAdded(itemType), 
						reloadTriggerOn: () => this.reloadTriggerOn(), 
						procImportExport: (v) => this.procImportExport(v), 
						toggleImportExportMenu: () => this.toggleImportExportMenu() 
					}} />
			)
		}
	}

	renderSectionList(item) {
		return (
			<div className="l-flex personal-inventory__container-full-width l-margin-x--auto l-margin-bottom--xl">
				<section id="personal-inventory-list-content" className="personal-inventory__list-item personal-inventory__container-full-width">
					{this.renderListHeader(item)}
					{this.renderListItem()}
				</section>
			</div>
		)
	}

	renderSectionListWithCatalogTree(item) {
		return (
			<React.Fragment>
				<div id="personal-inventory-list-content" className="personal-inventory__container-full-width personal-inventory__show-only-desktop l-margin-x--auto">
					<div className="personal-inventory__grid-cols l-margin-bottom--xl">
						{this.renderCategoryTreeView()}
						<div className="personal-inventory__list-item personal-inventory__grid-cols-cell-list l-full-width">
							{this.renderListHeader(item)}
							{this.renderListItem()}
						</div>
					</div>
				</div>

				<div className="personal-inventory__show-only-mobile-device">
					<div className="l-flex personal-inventory__container-full-width">
						<section className="personal-inventory__list-item personal-inventory__container-full-width">
							{this.renderListHeader(item)}
							{this.renderListItem()}
						</section>
					</div>
				</div>
			</React.Fragment>
		)
	}

	renderCategoryTreeModal() {
		const listCategory = CategoryUtil.getSelectedCategoryMapping(this.state.dispItemType, this.state.listCategory[this.state.dispItemType]);
		return (
			<CategoryTreeModal 
				key={listCategory + this.state.categoryTreeIter}
				data={{ itemType:this.state.dispItemType, listCategory: listCategory }} 
				func={{ 
					toggleCategoryTreeModal: () => this.toggleCategoryTreeModal(), 
					toggleCategory: (idCategory, selected) => this.toggleCategory(idCategory, selected),
					clearAllCategoryFilter: () => this.clearAllCategoryFilter()
				}} />
		)

	}

	renderCategoryTreeView() {
		const listCategory = CategoryUtil.getSelectedCategoryMapping(this.state.dispItemType, this.state.listCategory[this.state.dispItemType]);

		return (
			<CategoryTreeView key={listCategory + this.state.categoryTreeIter} data={{ itemType: this.state.dispItemType, listCategory: listCategory }} func={{ toggleCategory: (idCategory, selected) => this.toggleCategory(idCategory, selected) }} />
		)
	}

	renderListHeader(item) {
		const listCategory = CategoryUtil.getSelectedCategoryMapping(this.state.dispItemType, this.state.listCategory[this.state.dispItemType]);
		//const totalItemCntOnList = ItemListUtil.getCntListItem(this.state.listItem);
		return (
			<ListHeader
				key={listCategory + item + this.state.categoryTreeIter}
				data={{
					item: item
					, dispItemType: this.state.dispItemType
					, showCategoryTree: this.state.showCategoryTree[this.state.dispItemType]
					, strSearchKeyword: this.state.strSearchKeyword
					, listCategory: listCategory
					, listLotCnt : this.state.nListLotCnt
					, listItemCnt : this.state.nListItemCnt
				}}
				func={{
					updateListType: (type) => this.updateListType(type)
					, updateListSize: (e) => this.updateListSize(e)
					, updateSortType: (sortType) => this.updateSortType(sortType)
					, updateSortOrder: () => this.updateSortOrder()
					, toggleCategoryTreeView: () => this.toggleCategoryTreeView()
					, toggleCategoryTreeModal: () => this.toggleCategoryTreeModal()
					, toggleCategory: (idCategory, selected) => this.toggleCategory(idCategory, selected)
					, clearCategoryFilter: () => this.clearCategoryFilter()
				}}
			/>
		)
	}

	renderListItem() {
		const dispItemType = this.state.dispItemType;
		const listingOptions = this.getListingOption();
		const key = ItemListUtil.getListIterId() + this.state.dispItemType + this.state.reloadList;
		const listItem = this.state.listItem;
		const nListLotCnt = this.state.nListLotCnt;
		const itemCnt = this.getItemCnt(dispItemType);

		if (listingOptions == null) return null;
		if (Object.keys(listingOptions).length === 0) return null;
		
		return (
			<ItemView
				key={key}
				data={{
					myCollectionConfig: this.state.myCollectionConfig,
					reloadList: this.state.reloadList,
					dispItemType: dispItemType,
					nItemCnt: itemCnt.itemCnt,
					nLotCnt: nListLotCnt,
					listingOptions: listingOptions,
					itemPage: this.state.itemPage[dispItemType],
					listItem: listItem,
					showCategoryTree: this.state.showCategoryTree[dispItemType],
					strSearchKeyword: this.state.strSearchKeyword
				}}
				func={{
					reloadTriggerOn: () => this.reloadTriggerOn(),
					reloadTriggerOff: () => this.reloadTriggerOff(),
					openImportXMLModal: () => openImportXMLModal(),
					updateItemPage: (itemType, page) => this.updateItemPage(itemType, page),
					getGenInvInfo: () => this.getGenInvInfo(),
					updateSortType: (sortType) => this.updateSortType(sortType),
					updateSortOrder: () => this.updateSortOrder(),
					getListItem: (page) => this.getListItem(page),
					markAsDeletion: (idx, mark) => this.markAsDeletion(idx, mark),
					updateItemQty: (idx, qty) => this.updateItemQty(idx, qty),
					enableEditNote: (idx) => this.enableEditNote(idx),
					updateNoteContent: (idx, note) => this.updateNoteContent(idx, note),
					discardItemUpdates: () => this.discardItemUpdates()
				}}
			/>
		)

	}

	discardItemUpdates() {
		let listItem = this.state.listItem;
		for( const item of listItem ) {
			if (typeof item.newQty != "undefined" ) item.newQty = item.invQty;
			if (item.markedAsDeletion) item.markedAsDeletion = false;
			if (typeof item.newNote != "undefined" ) {
				item.newNote = item.note;
				item.editNote = false;
			}

		}
		this.setState({listItem:listItem});
	}

	markAsDeletion(idx, mark) {
		let listItem = this.state.listItem;
		listItem[idx].markedAsDeletion = mark;
		this.setState({listItem:listItem});
	}

	enableEditNote(idx) {
		let listItem = this.state.listItem;
		let item = this.state.listItem[idx];
		
		listItem[idx] = item;
		this.setState({listItem:listItem});
	}

	updateNoteContent(idx, note) {
		let listItem = this.state.listItem;
		listItem[idx].newNote = note;
		this.setState({listItem:listItem});
	}

	updateItemQty(idx, qty) {
		let listItem = this.state.listItem;
		let item = listItem[idx];
		const invId = item.invId;
		let newQty = 0;
		if (parseInt(qty) >= 0) {
			newQty = qty;
			listItem[idx].newQty = newQty;
		}
		else
		{
			listItem[idx].newQty = "";
		}

		this.setState({listItem:listItem});
	}
	
	updateListType(listType) {
		const itemType = this.state.dispItemType;
		let generalInvInfo = this.state.generalInvInfo;

		if (generalInvInfo.listingOptions[itemType].strListViewType != listType) {
			generalInvInfo.listingOptions[itemType].strListViewType = listType;
			this.setState({ generalInvInfo: generalInvInfo }, this.reqUpdateListingOptions(false));
		}
	}

	updateSortType(sortType) {
		const itemType = this.state.dispItemType;
		let generalInvInfo = this.state.generalInvInfo;

		generalInvInfo.listingOptions[itemType].nListSortType = sortType;
		this.setState({ generalInvInfo: generalInvInfo }, this.reqUpdateListingOptions(true));
	}

	updateSortOrder() {
		const itemType = this.state.dispItemType;
		let generalInvInfo = this.state.generalInvInfo;
		const curSortOrder = generalInvInfo.listingOptions[itemType].nListOrder;
		const newsortOrder = (curSortOrder == 1) ? 0 : 1;

		generalInvInfo.listingOptions[itemType].nListOrder = newsortOrder;
		this.setState({ generalInvInfo: generalInvInfo }, this.reqUpdateListingOptions(true));
	}

	updateListSize(e) {
		const nListSize = parseInt(e.target.value);
		const itemType = this.state.dispItemType;
		let generalInvInfo = this.state.generalInvInfo;

		if (generalInvInfo.listingOptions[itemType].nListSize != nListSize) {
			generalInvInfo.listingOptions[itemType].nListSize = nListSize;
			this.setState({ generalInvInfo: generalInvInfo }, this.reqUpdateListingOptions(true));
		}
	}

	getItemCnt(itemType) {
		return MyCollectionUtils.getItemCountByItemType( this.state.generalInvInfo, itemType);
	}

	toggleCategory(idCategory, selected) {
		if (selected) {
			CategoryUtil.removeSelectedCategory(this.state.dispItemType, idCategory);
		}
		else {
			CategoryUtil.addSelectedCategory(this.state.dispItemType, idCategory);
		}
		
		this.updateCategoryTree();
		this.getListItem(1);
		//this.setListCategory(this.state.dispItemType, this.state.listCategory);
	}

	clearCategoryFilter() {
		const dispItemType = this.state.dispItemType;
		CategoryUtil.clearCategoryFilter(dispItemType);
		this.updateCategoryTree();
		this.getListItem(1);
		//this.setListCategory(this.state.dispItemType, this.state.listCategory);
	}

	updateCategoryTree() {
		const categoryTreeIter = this.state.categoryTreeIter++;
		this.setState({categoryTreeIter: categoryTreeIter});
	}

	setListCategory(itemType, listCategory) {
		const newListCategory = CategoryUtil.getSelectedCategoryMapping(this.state.dispItemType, listCategory);
		this.setState({ listCategory: newListCategory });
	}

	changeSlide(index) {  /* WILLBE REMOVED */
		this.setState({ activeStory: index });
	}

	getListingOption() {
		//const dispItemType = (this.state.dispItemType == "A") ? "P" : this.state.dispItemType;
		const dispItemType =this.state.dispItemType;
		return this.state.generalInvInfo.listingOptions[dispItemType]
	}

	renderFTUXModal() {
		return (
			<FTUXModal func={{ closeTutorialModal: () => this.closeTutorialModal() }} />
		)
	}

	toggleImportExportMenu() {
		if (this.state.showImportExportMenu)
			$(".personal-inventory__import-export-selector-container").hide();
		else
			$(".personal-inventory__import-export-selector-container").show();
		this.setState({ showImportExportMenu: !this.state.showImportExportMenu });
	}

	renderErrorModal() {
		return (
			<ErrorModal data={{ errorType: 0, show: false }} />
		)
	}


	closeTutorialModal() {
		this.setState({ showTutorial: false });
	}

	getGenInvInfo(keyword = this.state.strSearchKeyword) {
		const listCategoryFilter = CategoryUtil.getSelectedCategory(this.state.dispItemType);
		
		if (!blapp.session.isLoggedIn()) {
			blapp.refs.get("header").toggleMenu("login");
		}
		else {
			MyCollectionProtocol.reqGenInvInfo(keyword, listCategoryFilter
			).then(
				(data) => {
					if (data != null) {
						
						if (data.bFirstVisit) {
							this.setState({ showTutorial: true });
						}

						if (data.listingOptions["S"] == null) data.listingOptions["S"] = this.getDefaultListingOption("S");
						if (data.listingOptions["P"] == null) data.listingOptions["P"] = this.getDefaultListingOption("P");
						if (data.listingOptions["M"] == null) data.listingOptions["M"] = this.getDefaultListingOption("M");
						if (data.listingOptions["C"] == null) data.listingOptions["C"] = this.getDefaultListingOption("C");
						if (data.listingOptions["B"] == null) data.listingOptions["B"] = this.getDefaultListingOption("B");
						if (data.listingOptions["G"] == null) data.listingOptions["G"] = this.getDefaultListingOption("G");

						if (data.listingOptions["S"].nListSize == 25) data.listingOptions["S"].nListSize = 24;
						if (data.listingOptions["S"].nListSize == 50) data.listingOptions["S"].nListSize = 48;
						if (data.listingOptions["S"].nListSize == 100) data.listingOptions["S"].nListSize = 96;
						if (data.listingOptions["S"].nListSize == 200) data.listingOptions["S"].nListSize = 192;

						if (data.listingOptions["P"].nListSize == 25) data.listingOptions["P"].nListSize = 24;
						if (data.listingOptions["P"].nListSize == 50) data.listingOptions["P"].nListSize = 48;
						if (data.listingOptions["P"].nListSize == 100) data.listingOptions["P"].nListSize = 96;
						if (data.listingOptions["P"].nListSize == 200) data.listingOptions["P"].nListSize = 192;

						if (data.listingOptions["M"].nListSize == 25) data.listingOptions["M"].nListSize = 24;
						if (data.listingOptions["M"].nListSize == 50) data.listingOptions["M"].nListSize = 48;
						if (data.listingOptions["M"].nListSize == 100) data.listingOptions["M"].nListSize = 96;
						if (data.listingOptions["M"].nListSize == 200) data.listingOptions["M"].nListSize = 192;

						if (data.listingOptions["C"].nListSize == 25) data.listingOptions["C"].nListSize = 24;
						if (data.listingOptions["C"].nListSize == 50) data.listingOptions["C"].nListSize = 48;
						if (data.listingOptions["C"].nListSize == 100) data.listingOptions["C"].nListSize = 96;
						if (data.listingOptions["C"].nListSize == 200) data.listingOptions["C"].nListSize = 192;

						if (data.listingOptions["B"].nListSize == 25) data.listingOptions["B"].nListSize = 24;
						if (data.listingOptions["B"].nListSize == 50) data.listingOptions["B"].nListSize = 48;
						if (data.listingOptions["B"].nListSize == 100) data.listingOptions["B"].nListSize = 96;
						if (data.listingOptions["B"].nListSize == 200) data.listingOptions["B"].nListSize = 192;

						if (data.listingOptions["G"].nListSize == 25) data.listingOptions["G"].nListSize = 24;
						if (data.listingOptions["G"].nListSize == 50) data.listingOptions["G"].nListSize = 48;
						if (data.listingOptions["G"].nListSize == 100) data.listingOptions["G"].nListSize = 96;
						if (data.listingOptions["G"].nListSize == 200) data.listingOptions["G"].nListSize = 192;

						const allItemCnt = data.nSetCount + data.nPartCount + data.nMinifigureCount + data.nBookCount + data.nCatalogCount + data.nGearCount;
						const allItemLotCnt = data.nSetLotCount + data.nPartLotCount + data.nMinifigureLotCount + data.nBookLotCount + data.nCatalogLotCount + data.nGearLotCount;
						data.nAllItemCount = allItemCnt;
						data.nAllItemLotCount = allItemLotCnt;
						
						this.setState({ generalInvInfo: data });

					}
				}
			).catch(
				(err) => {
					console.log(err)
				}
			);
		}
	}

	sortCategory(listCategory) {
		const catNameSort = (a, b) => {
			if ( a.catName < b.catName) {
			  return -1;
			} else if (a.catName == b.catName) {
			  return 0;
			} else {
			  return 1;
			}
		  };
		  return listCategory.sort(catNameSort);
	}

	getListCategory(keyword = this.state.strSearchKeyword) {
		if (!blapp.session.isLoggedIn()) {
			blapp.refs.get("header").toggleMenu("login");
		}
		else {
			MyCollectionProtocol.reqListCategory(
				keyword
			).then(
				(data) => {
					if (data != null) {
						
						const tmpListCategory = {
							B: this.sortCategory(data.B)
						,	C: this.sortCategory(data.C)
						,	G: this.sortCategory(data.G)
						,	M: this.sortCategory(data.M)
						,	P: this.sortCategory(data.P)
						,	S: this.sortCategory(data.S)
						}
						
						this.setState({ listCategory: tmpListCategory });
					}
				}
			).catch(
				(err) => {
					console.log(err)
				}
			);
		}

	}
	
	getDefaultListingOption(itemType) {
		return (
			{
				nListOrder:1, nListSize: 24, nListSortType: 1, strItemType: itemType, strListViewType: "L"
			}
		)
	}

	reqUpdateListingOptions(bReload) {
		const itemType = this.state.dispItemType;
		const listingOptions = this.state.generalInvInfo.listingOptions[itemType];

		MyCollectionProtocol.reqUpdateListingOptions(
			itemType
			, listingOptions
		).then(
			(data) => {
				if (data != null) {
					if (bReload) this.reloadTriggerOn();
					this.forceUpdate();
				}
			}
		).catch(
			(err) => {
				console.log(err);
			}
		)
	}

	changeItemType(newItemType) {
		const itemType = this.state.dispItemType;
		const page = this.state.itemPage[newItemType];

		if (itemType !== newItemType) {
			this.pushUrlState(page, newItemType, this.state.strSearchKeyword);
			//const newURL = blapp.util.addParamToUrl('page', page, blapp.util.addParamToUrl('itemType', newItemType, window.location));
			//history.pushState('', '', newURL);
			this.setState({ listItem: [], dispItemType: newItemType });

		}

	}

	getItemCnt(itemType) {
		const generalInvInfo = this.state.generalInvInfo;
		const totalLotCount = generalInvInfo.nSetLotCount + generalInvInfo.nPartLotCount + generalInvInfo.nMinifigureLotCount + generalInvInfo.nBookLotCount + generalInvInfo.nCatalogLotCount + generalInvInfo.nGearLotCount;
		const totalItemCount = generalInvInfo.nSetCount + generalInvInfo.nPartCount + generalInvInfo.nMinifigureCount + generalInvInfo.nBookCount + generalInvInfo.nCatalogCount + generalInvInfo.nGearCount;
		let itemCnt;
		let itemLotCnt;

		switch (itemType) {
			case "A":
				itemLotCnt = totalLotCount;
				itemCnt = totalItemCount;
				break;
			case "S":
				itemLotCnt = generalInvInfo.nSetLotCount;
				itemCnt = generalInvInfo.nSetCount;
				break;
			case "P":
				itemLotCnt = generalInvInfo.nPartLotCount;
				itemCnt = generalInvInfo.nPartCount;
				break;
			case "M":
				itemLotCnt = generalInvInfo.nMinifigureLotCount;
				itemCnt = generalInvInfo.nMinifigureCount;
				break;
			case "B":
				itemLotCnt = generalInvInfo.nBookLotCount;
				itemCnt = generalInvInfo.nBookCount;
				break;
			case "C":
				itemLotCnt = generalInvInfo.nCatalogLotCount;
				itemCnt = generalInvInfo.nCatalogCount;
				break;
			case "G":
				itemLotCnt = generalInvInfo.nGearLotCount;
				itemCnt = generalInvInfo.nGearCount;
				break;
		}
		return ({ itemCnt: itemCnt, itemLotCnt: itemLotCnt });
	}

	getListItem(page = this.state.itemPage[this.state.dispItemType], keyword = this.state.strSearchKeyword) {
		const strItemType = this.state.dispItemType;
		const nLotCnt = this.getItemCnt(strItemType).itemLotCnt;
		const listingOptions = this.getListingOption();
		let reqPage = (page == 0) ? 1 : page;
		const lastPage = Math.ceil(nLotCnt / listingOptions.nListSize);
		if (reqPage > lastPage) reqPage = (lastPage == 0) ? 1 : lastPage;
		const listCategoryFilter = CategoryUtil.getSelectedCategory(this.state.dispItemType);

		MyCollectionProtocol.reqGetListItem(
			strItemType, reqPage, listingOptions, keyword, listCategoryFilter
		).then(
			(data) => {
				let listItem = data.list;
				
				for (let item of listItem) {
					item.markedAsDeletion = false;
					item.editNote = false;
					item.note = (item.invNote == null)?"":item.invNote;
				}

				if (listItem != null) {
					
					if ( !CommonUtils.isEqualJSON(listItem, this.state.listItem) ) {
						ItemListUtil.increaseListIter();
					}
					
					this.setState({ listItem: listItem, nListLotCnt: data.lotCount, nListItemCnt: data.itemCount });
				}
			}
		).catch(
			(err) => {
				console.log(err);
			}
		);

	}

	updateItemPage(itemType, page) {
		let itemPage = this.state.itemPage;
		itemPage[itemType] = page;
		this.setState({ itemPage: itemPage });
	}

	onSessionUpdate() {
		if (blapp.session.isLoggedIn()) {
			this.reloadTriggerOn();
		}
	}

	onPopState(e) {
		const itemTypes = ["S", "P", "M", "B", "G", "C"];
		const qItemType = blapp.util.getUrlVar("itemType");
		const qPage = blapp.util.getUrlVar("page");

		let itemType = "S";
		let page = 1;

		if (typeof qItemType != "undefined") {
			if (itemTypes.includes(qItemType.toUpperCase())) {
				itemType = qItemType.toUpperCase();
			}
		}

		if (typeof qPage != "undefined") {
			page = parseInt(qPage);
			if (isNaN(page)) page = 1;
			if (page < 1) page = 1;
		}

		let itemPage = this.state.itemPage;
		itemPage[itemType] = page;

		this.reloadTriggerOn();
		this.setState({ dispItemType: itemType, dispPage: page, itemaPage: itemPage });

	}

	getCurrentItemType() {
		const dispItemType = this.state.dispItemType;
		const generalInvInfo = this.state.generalInvInfo;
		const listingOptions = generalInvInfo[dispItemType];

		switch (dispItemType) {
			case "A": return ({ itemType: "All", cnt: generalInvInfo.nAllItemCount, listingOptions: generalInvInfo.listingOptions.A });
				break;
			case "S": return ({ itemType: "Set", cnt: generalInvInfo.nSetCount, listingOptions: generalInvInfo.listingOptions.S });
				break;
			case "P": return ({ itemType: "Part", cnt: generalInvInfo.nPartCount, listingOptions: generalInvInfo.listingOptions.P });
				break;
			case "M": return ({ itemType: "Minifigure", cnt: generalInvInfo.nMinifigureCount, listingOptions: generalInvInfo.listingOptions.M });
				break;
			case "B": return ({ itemType: "Book", cnt: generalInvInfo.nBookCount, listingOptions: generalInvInfo.listingOptions.B });
				break;
			case "G": return ({ itemType: "Gear", cnt: generalInvInfo.nGearCount, listingOptions: generalInvInfo.listingOptions.G });
				break;
			case "C": return ({ itemType: "Catalog", cnt: generalInvInfo.nCatalogCount, listingOptions: generalInvInfo.listingOptions.C });
				break;
		}

	}

	pushUrlState(page, itemType, keyword)  {
		const newURL = blapp.util.addParamToUrl('page', page, blapp.util.addParamToUrl('itemType', itemType, blapp.util.addParamToUrl('q', keyword, window.location)));
		history.pushState('', '', newURL);
	}

	doSearch(keyword) {
		const itemType = this.state.dispItemType;
		const page = this.state.itemPage[itemType];

		if (keyword == this.state.strSearchKeyword) return;
		this.getGenInvInfo(keyword);
		
		this.pushUrlState(page, itemType, keyword);
		
		this.setState({ strSearchKeyword: keyword.trim() }, this.getKeywordListItem(keyword));
	}

	getKeywordListItem(keyword) {
		//const page = this.state.itemPage[this.state.dispItemType];
		
		this.getListCategory(keyword);
		this.getListItem(1, keyword);
	}

	clearListCategory() {
		const listCategory = { A: [], S: [], P: [], B: [], M: [], G: [], C: [] };
		this.setState({listCategory: listCategory});
	}

	clearAllCategoryFilter() {
		CategoryUtil.clearAllCategoryFilter();
		//this.setListCategory(this.state.dispItemType, this.state.listCategory);
		this.updateCategoryTree();
	}

	procImportExport(value) {
		const itemType = this.state.dispItemType;
		if (value == "I") {
			this.openImportXMLModal();
		}
		if (value == "E") {
			window.location.href = "/_file/my_personal_inventory/export.xml?itemType=" + itemType;
		}
		this.toggleImportExportMenu();
	}

	closeImportXMLModal() {
		this.reloadTriggerOn();
		this.setState({ showImportXMLModal: false });
	}

	reloadTriggerOn() {
		this.getGenInvInfo();
		this.getListCategory();
		this.getListItem();
		this.setState({ reloadList: true });
	}

	reloadTriggerOff() {
		this.setState({ reloadList: false });
	}

	openImportXMLModal() {
		this.setState({ showImportXMLModal: true });
	}

	setItemAdded(itemAdded, itemType) {
		AddItemUtil.setItemAdded(itemAdded[itemType], itemType);
	}

	getItemAdded(itemType) {
		return AddItemUtil.getItemAdded(itemType);
	}

	toggleCategoryTreeView() {
		let showCategoryTree = this.state.showCategoryTree;

		showCategoryTree[this.state.dispItemType] = (this.state.dispItemType == "A")?false:!showCategoryTree[this.state.dispItemType];
		this.setState({ showCategoryTree: showCategoryTree });
	}

	toggleCategoryTreeModal() {
		this.setState({ showCategoryModal: !this.state.showCategoryModal })
	}

	clearItemAdded(itemType) {
		AddItemUtil.clearItemAdded(itemType);
	}

	setOptionShowAddSection(optionShowItemAdd, itemType) {
		AddItemUtil.setOptionShowSection(optionShowItemAdd, itemType);
	}

	getOptionShowAddSection(itemType) {
		AddItemUtil.getOptionShowSection(itemType);
	}
};



document.addEventListener(
	"DOMContentLoaded"
	, function () {
		let content = ReactDOM.render(
			<PersonalInventory />
			, document.getElementById('bl-my-personal-inventory')
		);
	}
);